<script>
import layout from '@src/mixins/layout.vue'
import { peerCoachingService } from '@services/safehaven/PeerCoachingService'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import moment from 'moment'
import { format, parseISO } from 'date-fns'

export default {
  page: {
    title: 'Telehealth',
    meta: [{ name: 'description', content: 'The Telehealth page.' }],
  },
  mixins: [layout, NavigateMixin],

  data() {
    return {
      date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      currentDateWithFormat: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-'),
      selectDate: null,
      selectedProvider: null,
      selectedProviderId: '',
      providers: [],
      label: 'Select type of provider',
      enableButton: false,
    }
  },
  computed: {
    computedDateFormatted() {
      if (this.currentDateWithFormat === this.date) {
        return this.date
          ? moment(this.date).format('[Today], MMMM Do YYYY')
          : ''
      } else {
        return this.date ? moment(this.date).format('dddd, MMMM Do YYYY') : ''
      }
    },
    computedDateFormattedDatefns() {
      return this.date ? format(parseISO(this.date), 'EEEE, MMMM do yyyy') : ''
    },
    getEndDate() {
      var endDate = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        10
      )
      return endDate.toISOString().substr(0, 10)
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date)
    },
  },

  async mounted() {
    try {
      const providerData = (await peerCoachingService.getReasonProviderType())
        .data

      if (providerData) {
        this.providers = providerData.provider_type
      }
    } catch (error) {
      console.warn(error.response)
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    searchProviders() {
      this.$router.push({
        name: 'safehaven-provider-list',
        params: {
          selectedProvider: this.selectedProvider,
          selectedDate: this.date,
          selectedProviderId: this.selectedProviderId,
          loadDetails: false,
        },
      })
    },
    selectProvider() {
      this.enableButton = true
      this.providers.map((provider) => {
        if (this.selectedProvider === provider.provider_type) {
          this.selectedProviderId = provider.id
        }
      })
    },
  },
}
</script>

<template>
  <v-container>
    <v-row class="mt-2">
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        class="ma-auto"
        fill-height
      >
        <a :class="$style.clickable" class="primary--text" @click="goBack">
          <v-img
            v-if="!notDesktop"
            :class="$style.imgclss"
            :src="require('@assets/images/safehaven/back.png')"
            height="10"
            width="10"
            class="mr-2 mt-1"
          ></v-img>
          Back</a
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
        xl="4"
        :class="$style.paddingclss"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <h3 class="peerHeading">Telehealth</h3>
        <div :class="$style.text"
          >Schedule a confidential telehealth meeting with a peer coach or
          counselor to seek support for burnout, career fatigue, or other mental
          health issues.
        </div>
        <v-select
          v-model="selectedProvider"
          :class="$style.selectorclss"
          :items="providers"
          item-text="provider_type"
          item-value="key"
          class="mt-6 mb-1"
          dense
          :placeholder="label"
          outlined
          @change="selectProvider"
        ></v-select>
        <v-menu
          v-model="selectDate"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              slot="activator"
              :class="$style.dateInput"
              :value="computedDateFormatted"
              :rules="[(v) => !!v || 'Required']"
              append-icon="mdi-calendar"
              outlined
              dense
              readonly
              v-on="on"
              @click:append="on.click"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            :min="new Date().toISOString().substr(0, 10)"
            @change="selectDate = false"
          ></v-date-picker>
        </v-menu>
        <div>
          <v-btn
            :class="[
              'primary-btn',
              'full-width-btn',
              enableButton === false && 'disabled-btn',
            ]"
            @click="searchProviders"
          >
            Search Providers
          </v-btn>
        </div>
      </v-col>
      <v-col
        v-if="!notDesktop"
        class="pa-6"
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="8"
      >
        <v-img
          :src="require('@assets/images/safehaven/Telehealth.svg')"
          width="350"
          height="350"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.clickable {
  display: inline-flex;
  padding-left: 32px;
  font-size: 14px;
  text-align: left;
  vertical-align: middle;
}
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.imgclss {
  margin-top: 6px !important;
}
.link:hover,
a:visited {
  text-decoration: none;
}
.text {
  width: 80%;
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 22.5px !important;
  color: #2c3a4b;
}
.title {
  font-size: 28px;
  font-weight: 400;
}

.fullbtn {
  width: 100%;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.fullbtn:hover {
  text-decoration: none !important;
}
.paddingclss {
  padding-left: 40px !important ;
}
.dateInput {
  cursor: pointer;
}

@media screen and (max-width: 1263px) {
  .paddingclss,
  .clickable {
    padding-left: 0 !important ;
  }
  .text {
    width: 100%;
  }
}
@media screen and (max-width: 960px) {
  .fullbtn {
    width: 90%;
  }
}
@media screen and (max-width: 959px) {
  .paddingclss,
  .clickable {
    padding: 0 20px !important ;
  }
}
@media screen and (max-width: 599px) {
  .fullbtn {
    width: 100%;
    font-size: 14px;
  }
}
</style>

<style scoped>
.peerHeading {
  font-size: 22px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}

.appoinment {
  font-size: 18px !important;
  font-weight: 700;
  line-height: 22.5px !important;
}
/deep/ .textField input::placeholder {
  color: #000 !important;
  opacity: 1;
}
/deep/
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  cursor: pointer !important;
}
/deep/ .v-input input {
  font-size: 14px !important;
  cursor: pointer !important;
}
/deep/ .v-input input::placeholder {
  color: #000 !important;
}
/deep/ .v-input {
  font-size: 14px !important;
}
/deep/ .v-list-item__title {
  font-size: 14px !important;
}
</style>
